import React, { useRef } from 'react';
import styled from 'styled-components';
import { Modal } from 'antd';
import { theme } from 'utils/style/theme';

/**
 *
 * @param {node} children
 * @param {boolean} visible
 * @param {visible: boolean} setVisible
 * @param {string} title
 * @returns {다국어 포함된 수정용 모달. 빅사이즈}
 */

const LargeModal = ({
  children,
  visible,
  title,
  onCancel,
  style,
  footer,
  width,
  height,
}) => {
  /*
  /// 뒤로 가기
  const goBack = () => {
    handleCloser();
  };
*/
  /**
   
   useEffect(() => {
     //모달이 켜질때마다 새로운 state를 추가한다.
     window.history.pushState({ page: 'modal' }, window.document.title);
 
     //뒤로가기 버튼을 눌렀을 때 실행하는 이벤트리스너 등록
     window.addEventListener('popstate', goBack);
 
     //cleanup 함수로 컴포넌트가 사라질 때 모든 리스너를 제거해준다.
     return () => {
       window.removeEventListener('popstate', goBack);
     };
   }, [visible]);
   */
  return (
    <Container
      title={title}
      visible={visible}
      onCancel={onCancel}
      width={width ? width : '110rem'}
      footer={footer}
      style={style}
      height={height}
    >
      {children}
    </Container>
  );
};

export default LargeModal;

LargeModal.defaultProps = {
  footer: null,
};

const Container = styled(Modal)`
  top: 30px;
  .ant-modal-body {
    .input_wrap {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      margin-bottom: 1.8rem;
      height: 100%;
      /* border: solid 2px blue; */
      > div:nth-child(2) {
        /* max-height: none; */
        /* border: solid 2px yellow; */
        /* max-height: 100%; */
        /* height: 100%; */
        /* height: 46.5rem; */
      }
    }
    .survey {
      th {
        vertical-align: top;
      }
    }
    .button_wrap {
      text-align: center;
    }
    padding: 2rem 2rem 0;
    height: ${(props) => (props.height ? props.height : '')};
    overflow: scroll;
  }
  .ant-modal-title {
    font-weight: 900;
    color: ${theme.colors.blueText};
    margin: 0.5rem 0 0 0;
  }

  .submit_button_wrap {
    text-align: center;
  }
`;
